import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewCustomerCountByRecipientComponent } from './new-customer-count-by-recipient.component';

const routes: Routes = [ 
{
  path:'**',
  component: NewCustomerCountByRecipientComponent
}
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewCustomerCountByRecipientRoutingModule { }
